import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  loading: false,
  error: null,
};
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
      loginStart: (state) => {
        state.loading = true;
        state.error = null;
      },
      loginSuccess: (state, action) => {
        const { token, user } = action.payload.data; // Extract `token` and `user` from `data`
        state.currentUser = {
          id: user.id, // Extract `id` from `user`
          token: token, // Extract `token` from `data`
          user: user, // Store the entire `user` object
        };
        state.loading = false;
        state.error = null;
      },
      loginFailure: (state, action) => {
        state.loading = false;
        state.error = action.payload;
      },
      logout: (state) => {
        state.currentUser = null;
        state.loading = false;
        state.error = null;
      },
    },
  });

export const { loginStart, loginSuccess, loginFailure, logout } = userSlice.actions;
export default userSlice.reducer;